<template>
  <div>
    <el-form
      v-loading="isLoading"
      :model="account"
      size="small"
    >
      <el-form-item label="Account Active">
        <el-radio-group v-model="account.billing_active">
          <el-radio-button :label="true">
            Active
          </el-radio-button>
          <el-radio-button :label="false">
            Inactive
          </el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="MYOB Name">
        <el-input
          v-model="account.billing_qbname"
          placeholder="MYOB Name"
          clearable
        />
      </el-form-item>
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item label="ABN">
            <el-input
              v-model="account.billing_abn"
              placeholder="ABN"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item label="ACN">
            <el-input
              v-model="account.billing_acn"
              placeholder="ACN"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :md="8">
          <el-form-item label="Trading Terms (Days)">
            <el-input
              v-model="account.billing_terms_days"
              placeholder="Trading Terms (Days)"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item label="Trading Terms (Type)">
            <el-select
              v-model="account.trading_term"
              :loading="!tradingTerms.length > 0"
              value-key="id"
              placeholder="Trading Term (Type)"
              class="w-100"
              clearable
            >
              <el-option
                v-for="tradingTerm in tradingTerms"
                :key="tradingTerm.id"
                :label="`${tradingTerm.long}, ${tradingTerm.short}`"
                :value="tradingTerm"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item label="Invoice Cycle">
            <el-select
              v-model="account.time_cycle"
              :loading="!timeCycles.length > 0"
              value-key="id"
              placeholder="Invoice Cycle"
              class="w-100"
              clearable
            >
              <el-option
                v-for="timeCycle in timeCycles"
                :key="timeCycle.id"
                :label="`${timeCycle.long}, ${timeCycle.short}`"
                :value="timeCycle"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="Min Invoice Amount $">
        <el-input-number
          v-model="account.billing_invoice_minval"
          placeholder="Min Invoice Amount"
          controls-position="right"
        />
      </el-form-item>
      <el-form-item label="Invoice Requires Reconciliation">
        <el-switch v-model="account.billing_invoice_reqrecon" />
      </el-form-item>
      <el-form-item label="Bill Parent Directly">
        <el-switch v-model="account.billing_billparent" />
      </el-form-item>
      <el-form-item label="Account / Billing On Hold">
        <el-switch v-model="account.billing_onhold" />
      </el-form-item>
      <el-form-item label="On Hold Counter">
        <el-input-number
          v-model="account.billing_onholdcount"
          placeholder="On Hold Counter"
          controls-position="right"
          disabled
        />
      </el-form-item>
      <el-form-item label="MYOB ID">
        <el-input-number
          v-model="account.billing_myob_id"
          placeholder="Alternative MYOB ID"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      account: {},
      tradingTerms: [],
      timeCycles: []
    }
  },
  computed: {
    isMobileDevice () {
      return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    }
  },
  created () {
    this.readAccount()
    this.loadLists()
  },
  methods: {
    readAccount () {
      this.isLoading = true
      this.$sdk.account.read(this.accountId, builder => {
        builder.include = ['trading_term', 'time_cycle']
      })
        .then(acc => { this.account = acc })
        .finally(() => { this.isLoading = false })
    },
    loadLists () {
      // TRADING TERM
      this.$sdk.dictionary_tradingterm.list(builder => {
        builder.page = 1
        builder.limit = 1000
        builder.order = 'uuid:asc'
      }).then(res => { this.tradingTerms = res })
      // TIME CYCLE
      this.$sdk.dictionary_timecycle.list(builder => {
        builder.page = 1
        builder.limit = 1000
        builder.order = 'uuid:asc'
      }).then(res => { this.timeCycles = res })
    },
    saveBillingEdit () {
      this.isLoading = true
      this.account.update()
        .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
        .finally(() => { this.isLoading = false })
    }
  }
}
</script>

<style>

</style>
